import {Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {ActivationEnd, NavigationStart, Router} from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {ToolbarButton} from '../../models/toolbar-button/toolbar-button';
import {RouterSegments} from '../../models/router-segments';
import {ContactUsDialogComponent} from './contact-us-dialog/contact-us-dialog.component';
import {SidenavService} from '../../services/util/sidenav.service';
import {Permission} from 'src/app/models/principal/permission';
import {MatDialog} from '@angular/material/dialog';
import {PermissionsService} from '../../services/util/permissions.service';
// import { NotificationsListComponent } from '../../components/notifications/notifications-list/notifications-list.component';
import {NotificationsService} from '../../services/api/notifications.service';
import { NotificationsComponent } from './notifications/notifications.component';
import { BookmarksComponent } from './bookmarks/bookmarks.component';
import { SupportResourcesComponent } from './support-resources/support-resources.component';
import { Constants } from 'src/app/models/constants';

const REQUIRED_PERMISSIONS = [];

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent  implements OnInit {
  @Input() items;
  @Output() menuClick = new EventEmitter<boolean>();
  Constants = Constants;
  ToolbarButton = ToolbarButton;
  RouterSegments = RouterSegments;
  tenant: string;
  activeLink: string;
  hasMySandboxPermission: boolean;
  permissionsMap: { [key: string]: boolean };
  Permission = Permission;
  switchTenant: boolean;
private destroyRef = inject(DestroyRef);
  constructor(
    private authService: AuthService, private router: Router, public sidenavService: SidenavService,
    private matDialog: MatDialog, private permissionsService: PermissionsService,
    public notificationsService: NotificationsService
  ) {
    
    this.getActiveLink();
  }

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = '';
    this.tenant = this.authService.principal.provider;
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
  }

  openTenantDashboard(): void {
    this.router.navigate(['/',this.authService.principal.provider, 'tenant']);
  }

  menuClicked(): void {
    this.sidenavService.isExpanded = !this.sidenavService.isExpanded;
  }

  openHelpAndSupport(): void {
    this.sidenavService.openInRightSidenav(SupportResourcesComponent);
  }

  openContactUsForm(): void {
    this.sidenavService.openInRightSidenav(ContactUsDialogComponent);
  }

  onSwitchClick(): void {
    this.switchTenant = true;
    this.router.navigate(['/',this.authService.principal.provider, 'tenant']);
    localStorage.setItem('switchTenant', JSON.stringify(this.switchTenant));
  }

  openNotifications(): void {
    this.sidenavService.openInRightSidenav(NotificationsComponent);
  }

  bookmarksClick(): void {
    this.sidenavService.openInRightSidenav(BookmarksComponent);
  }

  // openNotificationsModal(): void {
  //   const data = {
  //     title: translate('NOTIFICATIONS.NOTIFICATIONS')
  //   };

  //   this.sidenavService.openInRightSidenav(NotificationsListComponent, data);
  // }
  /**
   * Gets the active link from the router data. Angular provides data to components inside the url tree, in which they are in. Therefore no
   * data is returned if we simply inject an instance of ActivatedRoute in components outside that tree (for instance the toolbar
   * component). We need to traverse all events and find the one with available activeLink data.
   *
   * https://github.com/angular/angular/issues/11812
   */
  private getActiveLink(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          // reset upon new navigation to allow the value of activeLink to change
          this.activeLink = null;
        } else if (event instanceof ActivationEnd && event?.snapshot?.data.activeLink) {
          this.activeLink = event.snapshot.data.activeLink;
        }
      });
  }
}
